export const OMSConfig = {
    STATUS_CODE_3: "受注残",
    STATUS_CODE_5: "出荷準備",
    STATUS_CODE_6: "出荷済み",
    STATUS_CODE_9: "キャンセル済み",
    OMS_DOWNLOAD_LIMIT: 1000,
    PACKAGING_SLIP_PDF_FILE_NAME_DEFAULT_TEXT:"納品書_",
    
};